export enum RecordType {
    DataController = "datacontroller",
    DataProcessor = "dataprocessor",
    ExtentedDataController = "extendeddatacontroller",
}
